// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"443":"about","631":"contact","686":"introduction","857":"shipping","929":"terms"}[chunkId] + "." + {"443":"e25a9c79","631":"01e9932c","686":"0fd775f5","857":"291afcbc","929":"9ac12092"}[chunkId] + ".js";
};